import { CircularProgress } from "@mui/material"
import { motion } from "framer-motion"
import React from "react"
import styled from "styled-components"
import { theme } from "../../../theme"

export type InfiniteScrollLoaderProps = {
  loadMoreText: string
}

export const InfiniteScrollLoader = (props: InfiniteScrollLoaderProps) => {
  return (
    <Root initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <GreyCircularProgress size={22} />
      <Label>{props.loadMoreText}</Label>
    </Root>
  )
}

const Root = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 43px 0;
  color: ${theme.color.grey2};
`

const GreyCircularProgress = styled(CircularProgress)`
  color: ${theme.color.grey2};
`

const Label = styled.span`
  font-size: ${theme.fontSize.s};
  margin-left: 10px;
`
